import React from 'react';

type CompanyHeaderProps = {
  company?: string;
  product?: string;
  tagline?: string;
};

export default function CompanyHeader({
  company = 'Pintar Studios',
  product = 'Web Tools',
  tagline = 'Implementation + Reference',
}: CompanyHeaderProps) {
  return (
    <div className="mx-auto flex max-w-6xl flex-col gap-1 px-5 py-4">
      <div className="flex items-center gap-3">
        <div>
          <h1 className="m-0 text-lg font-semibold">{company}</h1>
          <p className="m-0 text-sm text-slate-400">{product}</p>
        </div>
      </div>
      <p className="m-0 text-slate-400">{tagline}</p>
    </div>
  );
}
